export default "__VITE_ASSET__CSnrf2HO__"